<template>
  <div>
    <el-dialog
      title="申请免费试用"
      :visible.sync="mShow"
      center
      :before-close="handleClose"
    >
      <!-- top="100px" -->
      <div class="title">
        或拨打一对一咨询电话
        <span class="phone">180 1765 0737</span>
      </div>
      <div class="form">
        <el-form
          label-position="top"
          label-width="80px"
          :model="applyForm"
          :rules="rules"
          ref="form"
        >
          <el-form-item label="企业名称" prop="organName">
            <el-input
              v-model="applyForm.organName"
              placeholder="请输入您所在的企业名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="您的职务" prop="job">
            <el-input
              v-model="applyForm.job"
              placeholder="请输入您的职务"
            ></el-input>
          </el-form-item>
          <el-form-item label="您的姓名" prop="userName">
            <el-input
              v-model="applyForm.userName"
              placeholder="请输入您的姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <el-input
              v-model="applyForm.phone"
              placeholder="请输入您的联系方式"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input v-model="applyForm.code" placeholder="请输入验证码">
              <span
                @click="getCode"
                :disabled="getCodeisWaiting"
                class="contact_code"
                slot="append"
                >{{ getCodeText }}</span
              >
            </el-input>
            <!-- <span>{{ warningCodeText }}</span> -->
          </el-form-item>
          <div class="btn">
            <el-button @click="submit" class="submit">提交</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <div class="success">
      <el-dialog :visible.sync="successShow">
        <div class="successBox">
          <div class="image">
            <img src="../../src/assets/success1.png" alt="" />
          </div>
          <div class="message">
            <h1>提交成功</h1>
            <p>
              客户经理将会在2个工作日内与您联系,请您保持手机通畅,<br />注意接听。
            </p>
          </div>
          <div class="btn">
            <el-button @click="successShow = false">确认</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      mShow: this.show,
      successShow: false,
      getCodeisWaiting: false, // 验证码是否能被点击
      warningCodeText: "",
      getCodeText: "获取验证码",
      holdTime: 60,
      applyForm: {
        organName: "",
        job: "",
        userName: "",
        phone: "",
        code: "",
      },
      rules: {
        organName: [
          {
            required: true,
            message: "请输入您所在的企业名称",
            trigger: "blur",
          },
        ],
        job: [{ required: true, message: "请输入您的职务", trigger: "blur" }],
        userName: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入您的联系方式", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 获取验证码
    getCode() {
      if (!this.applyForm.phone) {
        this.$message({
          message: "请输入手机号",
          type: "error",
          offset: 80,
        });
        return;
      }
      let params = {
        phone: this.applyForm.phone,
      };
      this.$http
        .post("/upms/applyForUseRecord/getListForPhone", {
          phone: this.applyForm.phone,
        })
        .then((res) => {
          if (res.code !== "0") {
            return this.$message({
              message: res.msg,
              type: "error",
            });
          }
          if (res.data) {
            this.$http
              .get("/upms/phone/sendApplyCode", { params })
              .then((res) => {
                if (res.code !== "0") {
                  return this.$message({
                    message: res.msg,
                    type: "error",
                  });
                }
                this.setTimer();
              })
              .catch((error) => {
                this.$message({
                  message: error.response.data.msg ?? error.msg,
                  type: "error",
                  offset: 80,
                });
              });
          } else {
            this.$message({
              message: "该手机号已申请",
              type: "error",
              offset: 80,
            });
          }
        });
    },
    // 定时器
    setTimer() {
      this.Timer = setInterval(() => {
        if (this.holdTime <= 0) {
          this.getCodeisWaiting = false;
          this.getCodeText = "获取验证码";
          this.stopAllTimer();
          return;
        }
        this.getCodeText = this.holdTime + "s";
        this.holdTime--;
      }, 1000);
    },
    stopAllTimer() {
      clearInterval(this.Timer);
      this.Timer = null;
      this.getCodeisWaiting = false;
      this.getCodeText = "获取验证码";
    },
    // 提交
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http
            .post("/upms/applyForUseRecord/add", this.applyForm)
            .then((res) => {
              if (res.code !== "0") {
                return this.$message({
                  message: res.msg,
                  type: "error",
                  offset: 80,
                });
              }
              this.handleClose();
              this.successShow = true;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.form = "";
      clearInterval(this.Timer);
      this.getCodeText = "获取验证码";
      this.$refs.form.resetFields();
      this.mShow = false;
      // 允许滚动
      this.canScroll();
    },
  },
  watch: {
    show() {
      this.mShow = this.show;
    },
    mShow() {
      this.$emit("update:show", this.mShow);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog__title) {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333333;
  font-weight: bold;
}
:deep(.el-input-group__append) {
  border-left: none;
  background: none;
}
:deep(.el-button:focus, .el-button:hover) {
  color: #ffffff;
  border-color: none;
  background-color: none;
}
:deep(.el-form-item) {
  margin-bottom: 0.625rem;
}
:deep(.el-form--label-top .el-form-item__label) {
  padding: 0;
}
:deep(.el-input__inner) {
  // font-size: 18px;
}
/* .el-input-group--append .el-input__inner,
.el-input-group__prepend {
  border-right: none;
} */
.title {
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  color: #333333;
  padding-bottom: 0.625rem;
}
.phone {
  font-size: 1rem;
  font-weight: 400;
  color: #0e6eb8;
}
.form {
  padding: 0 0.125rem;
}
.contact_code {
  color: #0e6eb8;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
}
.btn {
  padding-top: 0.825rem;
}
.submit {
  width: 100%;
  background-color: #0e6eb8;
  font-size: 1.125rem;
  font-weight: 400;
  color: #ffffff;
}
.success {
  :deep(.el-dialog) {
    border-radius: 0.625rem !important;
  }
  .successBox {
    display: flex;
    flex-direction: column;
    margin: 0 2.5rem;
    .image {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 12.5rem;
        height: 12.5rem;
        object-fit: contain;
      }
    }
    .message {
      margin-bottom: 2.5rem;
      h1 {
        text-align: center;
        font-weight: 600;
        color: #000000;
        margin-bottom: 1.25rem;
      }
      p {
        text-align: center;
        font-weight: 500;
        color: #333333;
      }
    }
    .btn {
      button {
        width: 100%;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        background: #0e6eb8;
        padding: 0.9375rem 0;
      }
    }
  }
}
</style>
<style lang="scss">
// <600px
@media screen and (max-width: 600px) {
  .el-dialog {
    width: 85% !important;
  }
  .el-input__inner {
    font-size: 14px !important;
  }
}
// >730px
@media screen and (min-width: 730px) {
  .el-dialog {
    width: 500px !important;
  }
  .el-input__inner {
    font-size: 14px !important;
  }
  .success {
    .el-dialog {
      width: 490px !important;
    }
  }
}
</style>